<template>
  <div class="marquee-container bg-black overflow-hidden">
    <div class="marquee-content">
      <div class="marquee-track" :style="{ animationDuration: speed + 's' }" :class="directionClass">
        <div class="marquee-item">
          <template v-for="i in 35" :key="'first-' + i">
            <span class="text-hanken">{{ $t('marquee.dark.entrega') }}</span>
            <span class="arrow">→</span>
            <span class="text-hanken">{{ $t('marquee.dark.evolucao') }}</span>
            <span class="arrow">→</span>
            <span class="text-hanken">{{ $t('marquee.dark.estrategia') }}</span>
            <span class="arrow">→</span>
            <span class="text-hanken">{{ $t('marquee.dark.expressao') }}</span>
            <span class="arrow">→</span>
          </template>
        </div>
        <div class="marquee-item marquee-item-copy">
          <template v-for="i in 35" :key="'second-' + i">
            <span class="text-hanken">{{ $t('marquee.dark.entrega') }}</span>
            <span class="arrow">→</span>
            <span class="text-hanken">{{ $t('marquee.dark.evolucao') }}</span>
            <span class="arrow">→</span>
            <span class="text-hanken">{{ $t('marquee.dark.estrategia') }}</span>
            <span class="arrow">→</span>
            <span class="text-hanken">{{ $t('marquee.dark.expressao') }}</span>
            <span class="arrow">→</span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarqueeTextDark',
  props: {
    speed: {
      type: Number,
      default: 90 // segundos para completar uma volta
    },
    direction: {
      type: String,
      default: 'right', // 'left' ou 'right'
      validator: value => ['left', 'right'].includes(value)
    }
  },
  computed: {
    directionClass() {
      return `direction-${this.direction}`
    }
  },
  mounted() {
    // Garantir que a animação seja suave em todos os navegadores
    this.$nextTick(() => {
      const marqueeTrack = this.$el.querySelector('.marquee-track')
      if (marqueeTrack) {
        marqueeTrack.style.animationPlayState = 'running'
      }
    })
  }
}
</script>

<style scoped>
.marquee-container {
  position: relative;
  height: 80px;
  display: flex;
  align-items: center;
  background: #000000;
}

.marquee-content {
  width: 100%;
  overflow: hidden;
}

.marquee-track {
  display: flex;
  width: fit-content;
  will-change: transform;
}

.marquee-track.direction-left {
  animation-name: scroll-left;
  animation-duration: inherit;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.marquee-track.direction-right {
  animation-name: scroll-right;
  animation-duration: inherit;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.marquee-item {
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 0rem;
  flex-shrink: 0;
}

.marquee-item-copy {
  margin-left: 0rem;
}

.marquee-item span {
  font-size: 2.75rem;
  color: #ffffff;
  letter-spacing: 0em;
  margin-right: 1rem;
  flex-shrink: 0;
}

.text-hanken {
  font-family: 'Hanken Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  text-transform: uppercase;
}

.arrow {
  color: #ffffff;
  font-size: 1.75rem;
  flex-shrink: 0;
}

@keyframes scroll-left {
  0% {
    transform: translateX(50%);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .marquee-container {
    height: 60px;
  }
  
  .marquee-item span {
    font-size: 2.5rem;
  }
  
  .arrow {
    font-size: 2.5rem;
  }
  
  .marquee-item {
    gap: 0rem;
  }
  
}

@media (max-width: 480px) {
  .marquee-container {
    height: 60px;
  }
  
  .marquee-item span {
    font-size: 1.25rem;
    margin-right: 0.5rem;
  }
  
  .arrow {
    font-size: 1.25rem;
    margin-right: 0rem;
  }
  
  .marquee-item {
    gap: 1rem;
  }
  
  .marquee-item-copy {
    margin-left: 0.5rem;
  }
}

/* Variação da velocidade baseada na prop */
.marquee-item.speed-fast {
  animation-duration: 30s;
}

.marquee-item.speed-slow {
  animation-duration: 70s;
}

@keyframes scroll-right {
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(50%);
  }
}

/* Respeitar preferências de redução de movimento */
@media (prefers-reduced-motion: reduce) {
  .marquee-track {
    animation: none;
  }
  
  .marquee-container {
    justify-content: center;
    text-align: center;
  }
  
  .marquee-item-copy {
    display: none;
  }
}
</style> 